import { axiosInstance } from "../core/http";

export const authApi = {
  register: (data) => axiosInstance.post("/api/auth/register/", data),

  login: (data) => axiosInstance.post("/api/auth/token/", data),

  getUser: () => axiosInstance.get("/api/user/"),

  async getStatus() {
    /* Retrieve authenticated user status and his third-party
        services that have been connected to the account.
        If user is not authorized or authentication token has changed
        401 Unauthorized error will be returned. */

    const { data: userBase } = await axiosInstance.get("/panel/account/user");
    const { data: connections } = await axiosInstance.get(
      "/panel/account/connections"
    );
    return {
      ...userBase,
      connections,
    };
  },

  getPermissions: (userId) =>
    axiosInstance.get(`/panel/conflict-permission/user/${userId}/`),
};
